<template>
  <Container>
    <section class="text-center">
      <img src="./../assets/img/icons/rakete2.svg" class="mx-auto h-12" alt="">
      <div class="h1">Unsere Lieblingskunden</div>
      <p class="w-full md:max-w-3xl mx-auto text-left sm:text-center">Speedboot statt Riesentanker: Ein Auszug unserer Lieblingskunden, bei denen wir glücklich sind, sie bei ihrer Digitalisierung unterstützt zu haben, indem sie nun effektiv und agil sind wie ein Speedboot.</p>
      <div class="md:max-w-5xl mx-auto">
        <div class="justify-items-center robots-nocontent sm:mt-16 mx-4 sm:mx-0 lg:mb-24 md:mx-16 lg:mx-48 xl:mx-0 scale-105
        grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5
        gap-x-6 sm:gap-x-12
        gap-y-8 sm:gap-y-16 md:gap-y-8"
        id="refContainer">
          <img src="./../assets/img/logos/weinsmann.svg" alt="Weinsmann" class="-top-4 relative" />
          <img src="./../assets/img/logos/HannoverRe.svg" alt="Hannover Rück" />
          <img src="./../assets/img/logos/athlon.png" alt="Athlon" class="relative" />
          <img src="./../assets/img/logos/eckd.png" alt="ECKD - Dienstleistungen für Kirche & Wohlfahrt" class="top-[2px] left-4 relative" />
          <img src="./../assets/img/logos/trumpf.webp" alt="Trumpf" class="top-[1px] relative" />

          <img src="./../assets/img/logos/mfg.png" alt="MfG" class="-top-2 relative h-12" />
          <!-- <img src="./../assets/img/logos/tesla.png" alt="Tesla" class="top-[1px] relative" /> -->
          <img src="./../assets/img/logos/stroeer.png" alt="Ströer" class="top-[1px] left-1 relative" />
          <img src="./../assets/img/logos/weischer.jpg" alt="Weischer Media" class="" />
          <!-- <div></div>
          <div></div> -->
          <img src="./../assets/img/logos/brandstifter.svg" alt="Brandstifter" class="top-[1px] relative" />
          <img src="./../assets/img/logos/fernsehlotterie.jpg" alt="Deutsche Fernsehlotterie" class="top-[1px] relative" />
        </div>
      </div>
    </section>
  </Container>
</template>

<script>
import Container from './../views/Container.vue'

export default {
  name: 'References',
  components: {
    Container
  },
  methods: {
    onClickCta() {
      this.$emit('clicked', 'Projekt starten')
    }
  }
}
</script>

<style scoped>
#refContainer > * {
  max-height: 55px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  transition: all 0.2s;
}
  #refContainer > * {
    opacity: 0.7;
  }
  #refContainer > *:hover {
    -webkit-filter: grayscale(0%);
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.15);
  }
</style>